import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LabelList,
} from "recharts";

import {
  _formatNumber,
  _formatPrice,
} from "../../../../../../shared/helpers/utils";

const CustomBarChart = ({ theme, data , height=300, noSpecialChar=false, upperLabel=true, formatterPrice=true}) => {
  // Find the maximum value for dynamic Y-axis range
  const maxValue = Math.max(...data.map((item) => item.value));

  const formatter = (tickValue) => {

    if (!tickValue || noSpecialChar) return tickValue;
    return _formatPrice(tickValue); 
  };
console.log(data, "data")
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} barCategoryGap={10} margin={{ top: 20, right: 10, left: 10, bottom: 20 }}>
        {/* X-Axis */}
        <XAxis
          dataKey="name"
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 600,
          }}
        />
        {/* Y-Axis */}
        <YAxis
        axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          domain={[0, maxValue]}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 20,
            fontWeight: 600,
          }}
          tickFormatter={formatter}
        />
        <Bar
          dataKey="value"
          className="bar-element-chart"
          barSize={100} 
          radius={[16, 16, 0, 0]} // Rounded corners on top
          fill={theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)"}
        >
          {/* Value above the bar */}
        {upperLabel?   <LabelList
            dataKey="price"
            position="top"
            formatter={(value) => !formatterPrice? `$${_formatNumber(value)}`:_formatPrice(value)} 
            style={{
              fontSize: 20,
              fontWeight: 700,
             fill: theme === "dark" ? "#f8ffef" : "#fff"
            }}
          />:null}
          {/* Count inside the bar */}
          <LabelList
            dataKey="count"
            position="center"
            className="bar-chart-label"
            style={{
              fontSize: 20,
              fontWeight: 700,
              
          
            }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
